"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListItem = exports.wrapStyle = exports.disabledStyle = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const lodash_merge_1 = __importDefault(require("lodash.merge"));
const render_icon_1 = __importDefault(require("../../icons/render-icon"));
const create_use_styles_1 = __importDefault(require("../../theming/create-use-styles"));
const scroll_into_view_1 = __importDefault(require("../utils/scroll-into-view"));
const use_combined_refs_1 = __importDefault(require("../utils/use-combined-refs"));
const list_1 = require("./list");
function alignmentStyle(alignment) {
    switch (alignment) {
        case "start":
            return {
                alignItems: "flex-start",
            };
        case "end":
            return {
                alignItems: "flex-end",
            };
        case "center":
        default:
            return {
                alignItems: "center",
            };
    }
}
function disabledStyle(disabled, colors) {
    const styles = {
        color: colors.gray,
        backgroundColor: "transparent",
        cursor: "not-allowed",
        userSelect: "none",
        pointerEvents: "none",
    };
    return (!!disabled && {
        ...styles,
        "&:hover": styles,
        "&:active": styles,
    });
}
exports.disabledStyle = disabledStyle;
function wrapStyle(wrap) {
    return wrap
        ? {
            minWidth: 0,
            overflowWrap: "break-word",
        }
        : {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
        };
}
exports.wrapStyle = wrapStyle;
const useStyles = (0, create_use_styles_1.default)(({ colors, size, spacing }) => ({
    item: ({ active, alignItems, disabled, divider, hoverableItem, hoverableList }) => (0, lodash_merge_1.default)({
        "display": "flex",
        "padding": spacing("sm", "md"),
        "backgroundColor": hoverableItem ? colors.lightergray : active ? colors.lightprimary : undefined,
        "cursor": (hoverableItem !== null && hoverableItem !== void 0 ? hoverableItem : hoverableList) ? "pointer" : undefined,
        "&:hover": {
            backgroundColor: (hoverableItem !== null && hoverableItem !== void 0 ? hoverableItem : hoverableList) ? colors.lightergray : undefined,
        },
        "&:active": {
            backgroundColor: (hoverableItem !== null && hoverableItem !== void 0 ? hoverableItem : hoverableList) ? colors.lightprimary : undefined,
        },
        "&:not(:first-of-type)": {
            borderTop: divider ? `${size(1)} solid ${colors.lightgray}` : undefined,
        },
    }, alignmentStyle(alignItems), disabledStyle(!!disabled, colors)),
    leftIcon: {
        display: "flex",
        flexShrink: 0,
    },
    rightIcon: {
        display: "flex",
        flexShrink: 0,
    },
    text: ({ wrap }) => (0, lodash_merge_1.default)({
        "flexGrow": 1,
        "$leftIcon + &": {
            marginLeft: spacing(12),
        },
        "& + $rightIcon": {
            marginLeft: spacing(12),
        },
    }, wrapStyle(wrap)),
}));
exports.ListItem = react_1.default.forwardRef(function ListItem({ active, alignItems, children, className, disabled, divider, hoverable, leftIcon, rightIcon, scrollToView, ...props }, ref) {
    const context = (0, react_1.useContext)(list_1.ListContext);
    const classes = useStyles({
        active,
        alignItems: alignItems || context.alignItems,
        disabled,
        divider,
        hoverableList: context.hoverable,
        hoverableItem: hoverable,
        wrap: context.wrap,
    });
    const innerRef = (0, react_1.useRef)(null);
    const combinedRef = (0, use_combined_refs_1.default)(ref, innerRef);
    (0, react_1.useEffect)(() => {
        if (scrollToView) {
            setTimeout(() => { var _a; return (0, scroll_into_view_1.default)(innerRef.current, ((_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.parentElement) || null); });
        }
    }, [combinedRef, scrollToView]);
    return (react_1.default.createElement("li", { ref: combinedRef, className: (0, classnames_1.default)(classes.item, className), role: "menuitem", ...props },
        (0, render_icon_1.default)(leftIcon, classes.leftIcon),
        react_1.default.createElement("div", { className: classes.text }, children),
        (0, render_icon_1.default)(rightIcon, classes.rightIcon)));
});
exports.default = exports.ListItem;
//# sourceMappingURL=data:application/json;base64,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